import React from "react";
import PT from "prop-types";
import ClientMessengerSub from "_c/ClientMessengerSub";

const ClientNotifications = ({ client, t }) => {
  return (
    <ClientMessengerSub
      t={t}
      clientId={client._id}
      isClientRealUser={Boolean(client.user)}
      shouldUseSiteProxy
    />
  );
};
ClientNotifications.propTypes = {
  client: PT.object,

  t: PT.func.isRequired,
};
export default ClientNotifications;
